import React from "react";
import { Grid, Paper, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
import IncreaseDecreaseArrows from "../../components/increase-decrease-arrows/index.js";

const PlaylistsCard = ({ play_list, colours, FONT }) => {
    const navigate = useNavigate();

    return (
        <Paper
            sx={{ display: "flex", flexDirection: "column", width: '100%', borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
        >
            <CardHeaderTitle
                title="Playlists"
                tooltip="A quick indication of how many items are categorised in key Playlists."
                viewDetailTitle="View Details"
                viewDetailAction={() => navigate("/playlists")}
            />
            <Grid
                container
                spacing={0}
                direction="row"
                gap={3}
                marginTop={2}
            >
                <Grid item xs sm={3} sx={{ borderLeft: `3px solid`, borderColor: "success.main", paddingLeft: 1.5 }}>
                    <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>WOW Moments</div>
                    <Stack direction="row" gap={1}>
                        <div style={{ fontSize: FONT.SIZE_20, fontWeight: 600 }}>
                            {!play_list ? null : play_list.filter((item) => item.bookmark === "WOW moments").map(s => s.count).join(", ")}
                        </div>
                        <IncreaseDecreaseArrows increase={false} percentage="12%" />
                    </Stack>
                </Grid>

                <Grid item xs
                    sx={{ borderLeft: `3px solid`, borderColor: "warning.main", paddingLeft: 1.5 }}
                >
                    <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>High Risk</div>
                    <Stack direction="row" gap={1}>
                        <div style={{ fontSize: FONT.SIZE_20, fontWeight: 600 }}>
                            {!play_list ? null : play_list.filter((item) => item.bookmark === "High risk").map(s => s.count).join(", ")}
                        </div>
                        <IncreaseDecreaseArrows increase={true} percentage="4%" />
                    </Stack>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default PlaylistsCard;